import { isOneOfTags } from 'anodum';
import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';
import wrapIntoElement from './wrap-into-element';
import { IMAGE_TAG, BREAK_TAG } from '../constants/editable-elements';
import hasContentEditableAncestor from '../verifiers/has-content-editable-ancestor';

const shouldInsertParagraph = (element) =>
  !element || isOneOfTags(element, [IMAGE_SELECTOR, IMAGE_TAG]);

const createEmptyParagraph = (element) => {
  const lineBreak = element.ownerDocument.createElement(BREAK_TAG);
  return wrapIntoElement(lineBreak);
};

const handleMediaSiblings = (element) => {
  if (!hasContentEditableAncestor(element)) return;
  const { previousElementSibling, nextElementSibling } = element;

  if (shouldInsertParagraph(previousElementSibling)) element.before(createEmptyParagraph(element));
  if (shouldInsertParagraph(nextElementSibling)) element.after(createEmptyParagraph(element));
};

export default handleMediaSiblings;
